<template>
  <v-card>
    <v-card-title>Please Choose The Reason For Sign Out</v-card-title>
    <v-card-text>
      <div class="sign-out">
        <v-select :items="signOutReasonList" v-model="select" label="Please Select A Reason" item-text="text"
          item-value="value"></v-select>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="blue darken-1"
        text
        :disabled="saveDisable"
        @click="saveSignOutReason"
      >
        Sign Out
      </v-btn>
      <v-btn color="blue darken-1" text @click="hideDialog"> Cancel </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { Tool, Cache, Popup } from '@/util/index'
import { AuthApi } from '@/api/pandaria'

const tool = new Tool()
const cache = new Cache()
const popup = new Popup()
export default {
  name: 'sign-out',
  data () {
    return {
      signOutReasonList: [],
      select: '',
      saveDisable: true
    }
  },
  watch: {
    select (value) {
      if (value !== '') this.saveDisable = false
    },
    'store.getters.getSignOutReasonList' (val) {
      if (tool.isNotEmpty(val)) {
        this.signOutReasonList = val
      }
    }
  },
  mounted () {
    this.signOutReasonList = this.store.getters.getSignOutReasonList
  },
  methods: {
    hideDialog () {
      this.saveDisable = true
      this.select = ''
      this.$emit('hideSignOutDialog')
    },
    signOut () {
      const $this = this
      const token = cache.getAccessToken()
      const data = {
        token: token,
        reason: Number($this.select)
      }
      AuthApi.signOut(data, function () {
        window.getApp.$emit('APP_LOGOUT')
        window._VMA.$emit('SHOW_SNACKBAR', {
          text: 'Logout Successful',
          color: 'success',
          timeout: 1000
        })
      }, function (err) {
        popup.popupForWarning(err.message)
      })
    },
    saveSignOutReason () {
      this.signOut()
    }
  }
}
</script>

<style scoped lang="css">
.sign-out {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.sign-out button {
  margin: 0 10px;
  width: 20%;
}
.sign-out {
  width: 100% !important;
}
</style>
